import types from "./types";

export const createSurveyForm = (payload) => ({
    type: types.CREATE_SURVEY_FORM, payload
})
export const createSurveyFormResponse = (payload) => ({
    type: types.CREATE_SURVEY_FORM_RESPONSE, payload
})
export const createSurveyFormClear = () => ({
    type: types.CREATE_SURVEY_FORM_CLEAR
})

export const fetchSurveyForm = (payload) => ({
    type: types.FETCH_SURVEY_FORM, payload
})
export const fetchSurveyFormResponse = (payload) => ({
    type: types.FETCH_SURVEY_FORM_RESPONSE, payload
})
export const fetchSurveyFormClear = () => ({
    type: types.FETCH_SURVEY_FORM_CLEAR
})

export const submitSurveyForm = (payload) => ({
    type: types.SUBMIT_SURVEY_FORM, payload
})
export const submitSurveyFormResponse = (payload) => ({
    type: types.SUBMIT_SURVEY_FORM_RESPONSE, payload
})
export const submitSurveyFormClear = () => ({
    type: types.SUBMIT_SURVEY_FORM_CLEAR
})